var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.available
    ? _c(
        "div",
        {
          staticClass: "vds-deploylog"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center mb-1"
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-2 vds-deploylog__icon",
                  attrs: {
                    "x-small": "",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-text-box-outline")]
              ),
              _c(
                "span",
                {
                  staticClass: "text-caption mr-auto vds-deploylog__label"
                },
                [_vm._v("Install log")]
              ),
              _vm.loadingLog
                ? _c(
                    "span",
                    {
                      staticClass: "text-caption vds-deploylog__updating",
                      attrs: {
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("updating…")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "pre",
            {
              ref: "log",
              staticClass: "vds-deploylog__body",
              attrs: {
                tabindex: "0",
                role: "log",
                "aria-live": "polite",
                "aria-label": "Install log",
                "aria-busy": _vm.loadingLog ? "true" : "false"
              }
            },
            [
              _vm._v(
                _vm._s(_vm.displayContent || "Waiting for install output…")
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }